import React from "react";
import { MDBInput, MDBTextArea, MDBBtn, MDBSpinner } from "mdb-react-ui-kit";
import Select from "react-select";
import translations from "../../data/translations";
import arabicCountries from "../../data/jsons/citiescountrymappedarabic.json";
import englishCountries from "../../data/jsons/citiescountrymappedenglish.json";
import hebrewCountries from "../../data/jsons/citiescountrymappedhebrew.json";
import { parseLocationData } from '../../utils/ParsingLocationData';

const GuestBookForm = ({
  name,
  setName,
  country,
  setCountry,
  city,
  setCity,
  message,
  setMessage,
  language,
  setLanguage,
  errors,
  loading,
  sendMessage,
  buttonColor = "#76a4bb",
}) => {
  const isRtl = language === "hebrew" || language === "arabic";
  const textAlign = isRtl ? "right" : "left";
  const dir = isRtl ? "rtl" : "ltr";

  // Use the parsing function to get countries and citiesByCountry
  let countries, citiesByCountry;
  if (language === "hebrew") {
    ({ countries, citiesByCountry } = parseLocationData(hebrewCountries));
  } else if (language === "arabic") {
    ({ countries, citiesByCountry } = parseLocationData(arabicCountries));
  } else {
    ({ countries, citiesByCountry } = parseLocationData(englishCountries));
  }

  // Reset selects when language changes
  React.useEffect(() => {
    setCountry(null);
    setCity(null);
  }, [language, setCountry, setCity]);

  const cityOptions =
    country && citiesByCountry[country.value]
      ? citiesByCountry[country.value]
      : [];
  return (
    <>
      <div>
        {/* Name Input */}
        {errors.name && (
          <div style={{ color: "red", fontSize: "0.9em", textAlign }}>
            {errors.name}
          </div>
        )}
        <MDBInput
          wrapperClass="mb-2"
          label={
            <span
              className={
                isRtl ? "mdb-label-align-right" : "mdb-label-align-left"
              }
            >
              {translations[language].name}
            </span>
          }
          id="form1"
          type="text"
          dir={dir}
          value={name}
          onChange={(e) => setName(e.target.value)}
          invalid={!!errors.name}
          inputStyle={{ textAlign }}
          style={{ textAlign }}
        />

        {/* Country Select */}
        {errors.country && (
          <div style={{ color: "red", fontSize: "0.9em", textAlign }}>
            {errors.country}
          </div>
        )}
        <div className="mb-2">
          <Select
            options={countries}
            value={country}
            onChange={(selected) => {
              setCountry(selected);
              setCity(null);
            }}
            placeholder={translations[language].country}
            isClearable
            isSearchable
            noOptionsMessage={() => "No country found"}
          />
        </div>

        {/* City Select */}
        {errors.city && (
          <div style={{ color: "red", fontSize: "0.9em", textAlign }}>
            {errors.city}
          </div>
        )}
        <div className="mb-2">
          <Select
            options={cityOptions}
            value={city}
            onChange={setCity}
            placeholder={translations[language].city}
            isClearable
            isDisabled={!country}
            isSearchable
            noOptionsMessage={() =>
              country ? "No city found" : "Select a country first"
            }
          />
        </div>

        {/* Message Input */}
        {errors.message && (
          <div style={{ color: "red", fontSize: "0.9em", textAlign }}>
            {errors.message}
          </div>
        )}
        <MDBTextArea
          label={
            <span
              className={
                isRtl ? "mdb-label-align-right" : "mdb-label-align-left"
              }
            >
              {translations[language].message}
            </span>
          }
          id="form3"
          rows={8}
          style={{ minHeight: "100px", textAlign }}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          dir={dir}
          invalid={!!errors.message}
        />
        {/* Submit Button */}
        <MDBBtn
          className="w-100 my-3"
          size="md"
          style={{
            backgroundColor: buttonColor,
            borderColor: buttonColor,
            color: "#fff",
          }}
          onClick={() => {
            if (!loading)
              sendMessage(
                name,
                country ? country.value : "",
                city ? city.value : "",
                message
              );
          }}
          disabled={loading}
        >
          {loading ? (
            <MDBSpinner size="sm" role="status" tag="span" />
          ) : (
            translations[language].send
          )}
        </MDBBtn>

        {/* Language Buttons */}
        <div className="d-flex justify-content-center gap-2 flex-wrap">
          {[
            { code: "hebrew", label: "עברית" },
            { code: "english", label: "English" },
            { code: "arabic", label: "عربي" },
          ].map((lang) => (
            <button
              key={lang.code}
              style={{
                backgroundColor:
                  language === lang.code ? buttonColor : "#e6f0f6",
                color: language === lang.code ? "#fff" : "#234",
                border: "none",
              }}
              className="btn"
              onClick={() => setLanguage(lang.code)}
            >
              {lang.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default GuestBookForm;